/* eslint-disable camelcase */
/* eslint-disable new-cap */
import LaserEnd from './LaserEnd';
import SelectionSpot from './SelectionSpot';
import gameData from '../../gameData';
import AudioPlayer from '../../library/AudioPlayer';

export default class SelectionTray {
  constructor(game, countBy) {
    this.game = game;

    const selectionSpace = 80;
    const startX = 152;
    const laserOffset = 30;
    const y = 150;
    this.selectionSpots = [];

    this.rightLaser = new LaserEnd(game, game.scale.width + laserOffset, y, true);
    this.leftLaser = new LaserEnd(game, laserOffset, y, false);

    for (let i = 9; i > -1; i--) {
      const selectionLocation = new SelectionSpot(this.game, startX + (selectionSpace * i), y + 20, gameData.indexStart + ((i + 1) * countBy));
      this.selectionSpots.push(selectionLocation);
      this.game.add.existing(selectionLocation);
    }

    this.selectionSpots.reverse();
  }

  AnimateOut() {
    this.rightLaser.FadeBeam();
    this.leftLaser.FadeBeam();
    for (let i = 0; i < this.selectionSpots.length; i++) {
      this.selectionSpots[i].Destroy();
    }
    this.game.time.addEvent({ delay: 500, callback: () => {this.eh_PlayExplosionSound();} });
  }

  eh_PlayExplosionSound() {
    AudioPlayer.PlaySound(this.game, AudioPlayer.sounds.METEOR_EXPLOSION);
  }

  Update() {
    for (let i = 0; i < this.selectionSpots.length; i++) {
      this.selectionSpots[i].Update(i);
    }
  }

  GetNextCoord() {
    return this.nextSpot().GetCoords();
  }

  GetSelectionSpotByNumber(number) {
    for (let i = 0; i < this.selectionSpots.length; i++) {
      if (this.selectionSpots[i].GetNumber() === number) {
        return this.selectionSpots[i];
      }
    }
  }

  SetMeteor(meteor, posDiff) {
    this.nextSpot().SetMeteor(meteor, posDiff);
  }

  TrayFilled() {
    for (let i = 0; i < this.selectionSpots.length; i++) {
      if (!this.selectionSpots[i].IsPopulated()) {
        return false;
      }
    }
    return true;
  }

  nextSpot() {
    for (let i = 0; i < this.selectionSpots.length; i++) {
      if (!this.selectionSpots[i].IsPopulated()) {
        return this.selectionSpots[i];
      }
    }
    return null;
  }
}


